/**
 * Route params for one organization user, with the address decoded.
 *
 * The link into this section percent-encodes the address (organization/view),
 * and it has to: "@" is only the common case, but a valid local part may also
 * carry "/", "?" or "#", any of which would otherwise end the path segment.
 *
 * React Router 5 does not decode on the way back out — matchPath fills params
 * straight from the regex match, so `params.email` is the raw segment,
 * "someone%40example.com". Everything below wants the address itself: the
 * breadcrumb renders it, and the UserGet query and the edit/remove mutations
 * pass it to `users.get(email:)`, which matches the range key exactly and
 * therefore finds nothing at all for the encoded form.
 *
 * Decode once, here, rather than at each of the four call sites.
 */
export const userParams = (params) => ({
  ...params,
  email: decodeURIComponent(params.email),
});
